export class Module {
  constructor(
    public enabled: boolean,
    public name: string,
    public components: Array<string>
  ) {}
}
